import {
  BUSINESS_RELATIONSHIPS_OPTIONS,
  type BusinessRelationship,
} from '../constants/business-activity';

const businessRelationshipSet = new Set<string>(BUSINESS_RELATIONSHIPS_OPTIONS);

export function isBusinessRelationship(value: string): value is BusinessRelationship {
  return businessRelationshipSet.has(value);
}

export function toBusinessRelationship(
  value: string | null | undefined
): BusinessRelationship | null {
  if (typeof value !== 'string' || !isBusinessRelationship(value)) return null;
  return value;
}

export function toBusinessRelationships(
  values: readonly string[] | null | undefined
): BusinessRelationship[] {
  if (!values) return [];
  return values.filter(isBusinessRelationship);
}
